import { useEffect, useState } from 'react';
import { ClbButton, ClbSelect } from 'libs/celebration';
import { getCenters } from 'pages/master-data/general-configuration/general/general-master-data.service';
import { searchSuppliers } from 'services/filters.service';
import { isUseFilterDefault } from 'utils/user';
import { mapperOptionsToSelectBoxClb } from 'utils/celebration';
import { useLoadBuildingContext } from 'features/load-building/context';
import intl from 'react-intl-universal'
import * as S from './styled'
import { validateValidFilter } from 'features/load-building/utils';
import { generateQueryParams } from 'utils/custom-functions';
import { useToastContext } from 'hooks/useToastContext';

export const LoadBuildingFilter = () => {
  const [businessUnits, setBusinessUnits] = useState([])
  const [storageLocation, setStorageLocation] = useState([])
  const [suppliers, setSuppliers] = useState([])
  const [filterComponent, setFilterComponent] = useState({})
  const { openToast } = useToastContext()

  const {
    setFilter,
    setVolumesSelected,
    volumesSelected,
    setOpenFlowBuild,
    setBusinessUnitsRegisters,
    volumesSelectedData,
    setVolumesSelectedData,
    businessUnitsRegisters,
  } = useLoadBuildingContext()

  const loadSuppliersFilter = async (value) => {
    const query = { IdUnidadeNegocio: [value], UserInternalSupplier: true };

    const _suppliers = await searchSuppliers(isUseFilterDefault(), generateQueryParams(query));

    setSuppliers(mapperOptionsToSelectBoxClb(_suppliers, "Id", "Description"));

    const unidade = businessUnitsRegisters.find((item) => item.IdUnidadeNegocio == value);

    const storageLocation = unidade ? unidade.StorageLocation : [];

    const tempStorageLocation = [{ Description: "N/A", Id: 0, StorageLocation: "N/A" }, ...storageLocation];

    const mappedStorageLocation = mapperOptionsToSelectBoxClb(tempStorageLocation, "Id", "Description");

    setStorageLocation(mappedStorageLocation);

    if (mappedStorageLocation.length > 0) {
      setFilterComponent((prevState) => ({
        ...prevState,
        StorageLocationId: mappedStorageLocation[0].value,
      }));
    }
  };

  const loadBusinessUnitsFilter = async () => {
    const _businessUnits = await getCenters()
    setBusinessUnitsRegisters(_businessUnits)

    setBusinessUnits(
      mapperOptionsToSelectBoxClb(_businessUnits, 'IdUnidadeNegocio', 'Descricao')
    )
  }

  const handleUpdateFilter = (field, value) => {
    setFilterComponent((prevState) => ({
      ...prevState,
      [field]: value,
      ...(field === 'BusinessUnitId' && { StorageLocationId: null }),
    }))

    if (field === 'BusinessUnitId') {
      loadSuppliersFilter(value)
    }
  }

  const handleFilter = () => {
    setVolumesSelected([]);
    setVolumesSelectedData([]);
    setFilter((prevState) => ({
      ...prevState,
      ...filterComponent,
    }));
  }

  const validateVolumesToBuild = (data) => {
    const _storageLocations = data?.map((x) => x.BusinessUnitStorageLocationId)

    return [...new Set(_storageLocations)].length == 1
  }

  const handleOpenFlowBuild = () => {
    if (validateVolumesToBuild(volumesSelectedData)) {
      setOpenFlowBuild(true)
    } else {
      openToast(
        intl.get('load-building.feedback.storageLocationsMustBeEqual'),
        'negative'
      )
    }
  }

  useEffect(() => {
    loadBusinessUnitsFilter()
  }, [])

  const quantityVolumesSelected = volumesSelected?.length

  return (
    <S.Wrapper>
      <ClbSelect
        id="destination"
        data-testid="destiny-select"
        className="select"
        label={intl.get("commons.destiny")}
        size={"lg"}
        placeholder={intl.get("commons.destiny")}
        requiredMessage={intl.get("commons.required")}
        options={businessUnits}
        value={filterComponent.BusinessUnitId}
        onClbChange={(e) => handleUpdateFilter("BusinessUnitId", e.detail.value)}
        showMessage
        required
      />

      <ClbSelect
        id="storageLocationId"
        data-testid="storageLocation-select"
        className="select"
        label={intl.get("master-data.general-configuration.storageLocationAbbreviation")}
        size={"lg"}
        placeholder={intl.get("master-data.general-configuration.storageLocationAbbreviation")}
        disabled={storageLocation.length == 0}
        options={storageLocation}
        value={filterComponent.StorageLocationId}
        onClbChange={(e) => handleUpdateFilter("StorageLocationId", e.detail.value)}
      />

      <ClbSelect
        id="supplier"
        data-testid="supplier-select"
        className="select"
        label={intl.get("commons.supplier")}
        size={"lg"}
        placeholder={intl.get("commons.supplier")}
        requiredMessage={intl.get("commons.required")}
        options={suppliers}
        value={filterComponent.SupplierId}
        onClbChange={(e) => handleUpdateFilter("SupplierId", e.detail.value)}
        showMessage
        required
        disabled={!suppliers?.length}
      />
      <ClbButton
        size="md"
        styleType="secondary"
        className="btn"
        onClbClick={handleFilter}
        data-testid="search-btn"
        disabled={!validateValidFilter(filterComponent)}
      >
        {intl.get("filters.search")}
      </ClbButton>

      <ClbButton
        onClbClick={handleOpenFlowBuild}
        size="md"
        styleType="primary"
        className="btn btn-build"
        disabled={!quantityVolumesSelected}
        data-testid="btn-build"
      >
        {intl.get("commons.loadBuild")}
        <p>({quantityVolumesSelected})</p>
      </ClbButton>
    </S.Wrapper>
  );
}